import React from 'react';
import PropTypes from 'prop-types';
import FormGroupRow from "./FormGroupRow";

const FormGroupRowDateTime = ({label, required, value, onChange, description}) => (
    <FormGroupRow label={label} required={required} description={description}>
        <input type="datetime-local" className="form-control" value={value} onChange={event => onChange(event.target.value)}/>
    </FormGroupRow>
);

FormGroupRowDateTime.propTypes = {
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    description: PropTypes.any,
};

export default FormGroupRowDateTime;